module.exports = __webpack_public_path__ + "img/culling.32697251.png";